import http from '@/utils/services/http'

export function cadastro (preretirada, id) {
  if (typeof id !== 'undefined') {
    return this.atualizacao(preretirada, id)
  }
  return http.post('/api/preretirada', preretirada)
    .then(response => {
      return Promise.resolve(response)
    })
    .catch(({response}) => {
      return Promise.reject(response)
    })
}
export function cadastroSemBoleto (preretirada, id) {
  if (typeof id !== 'undefined') {
    return this.atualizacao(preretirada, id)
  }
  return http.post('/api/preretirada-sem-boleto', preretirada)
    .then(response => {
      return Promise.resolve(response)
    })
    .catch(({response}) => {
      return Promise.reject(response)
    })
}

export function registraChavePix (id, chavePix) {
  return http.patch(`/api/preretirada/${id}/registra-chave-pix`, {chavePix})
    .then(response => {
      return Promise.resolve(response)
    })
    .catch(({response}) => {
      return Promise.reject(response)
    })
}

export function alteraStatusParaPendente (id) {
  return http.patch(`/api/preretirada/${id}/altera-status-para-pendente`)
    .then(response => {
      return Promise.resolve(response)
    })
    .catch(({response}) => {
      return Promise.reject(response)
    })
}

export function alteraDataPagamento (id, novaDataPagamento) {
  return http.patch(`/api/preretirada/${id}/altera-data-pagamento`, {dataPagamento: novaDataPagamento})
    .then(response => {
      return Promise.resolve(response)
    })
    .catch(({response}) => {
      return Promise.reject(response)
    })
}

export function alteraPixPagador (id, pixPagador) {
  return http.patch(`/api/preretirada/${id}/altera-pix-pagador`, {pixPagador})
    .then(response => {
      return Promise.resolve(response)
    })
    .catch(({response}) => {
      return Promise.reject(response)
    })
}

export function deletePreRetirada (id) {
  return http.delete('/api/preretirada/' + id)
    .then(response => {
      return Promise.resolve(response)
    })
    .catch(({response}) => {
      return Promise.reject(response)
    })
}

export default {
  list () {
    return http.get('/api/preretirada/')
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  cadastrar () {
    return http.post('/api/preretirada/new')
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  find (id) {
    id = parseInt(id)
    if (id < 1) return Promise.reject()
    return http.get('/api/preretirada/' + id)
      .then(response => {
        console.log(response)
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  update (id) {
    return http.patch('/api/preretirada/' + id + '/update')
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  }
}



// WEBPACK FOOTER //
// ./src/domain/pre-retirada/services/index.js